import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import { RootState } from "../../../../state-management/root-reducer";
import { PaginationController } from "../../pagination/Pagination.controller";
import { PAGINATION_PAGE_SIZE } from "../../pagination/Pagination.types";
import PageCounterStyles from "./PageCounter.styles";
import {
  DefaultPageCounterProps,
  IPageCounterProps,
} from "./PageCounter.types";

// istanbul ignore next
const getTotalCountText = (
  searchTerm: string | null,
  totalCount: number
): React.ReactNode => {
  const resultsText = totalCount === 1 ? "Result" : "Results";
  const projectsText = totalCount === 1 ? "Project" : "Projects";

  return `${totalCount} ${
    searchTerm && searchTerm.length ? resultsText : projectsText
  }`;
};

const getPageCountForDisplay = (currentPage: number, totalCount: number) => {
  /* istanbul ignore next */
  if (currentPage * PAGINATION_PAGE_SIZE > totalCount) {
    return `Showing ${
      (currentPage - 1) * PAGINATION_PAGE_SIZE + 1
    } - ${totalCount}`;
  } else {
    /* istanbul ignore next */
    return `Showing ${(currentPage - 1) * PAGINATION_PAGE_SIZE + 1} - ${
      currentPage * PAGINATION_PAGE_SIZE
    }`;
  }
};

/**
 * PAGE_COUNTER
 * @param {IPageCounterProps} props
 * @return {*}
 */
const PAGE_COUNTER: React.FC<IPageCounterProps> = (
  props: IPageCounterProps
) => {
  const paginationController = PaginationController.getInstance();

  // APP STATE
  const { totalCount, currentPage } = useSelector(
    (state: RootState) => state.pagination
  );
  const { searchTerm } = useSelector((state: RootState) => state.search);

  // LOCAL STATE
  const [numPages, setNumPages] = useState<number>();

  useEffect(() => {
    // istanbul ignore next
    if (totalCount) {
      setNumPages(paginationController.getNumberOfPages(totalCount));
    }
  }, [totalCount, paginationController]);

  return (
    <PageCounterStyles.PageCounter
      data-testid="page-counter"
      className={`page-counter ${
        /* istanbul ignore next */ !isMobile ? "ms-auto" : ""
      }`}
      {...props}
    >
      {
        /* istanbul ignore next */ totalCount > 0 && (
          <div>{getTotalCountText(searchTerm, totalCount)}</div>
        )
      }

      {
        /* istanbul ignore next */ numPages && totalCount > 0 && (
          <>
            <div className="vr"></div>
            <div>{getPageCountForDisplay(currentPage, totalCount)}</div>
          </>
        )
      }
    </PageCounterStyles.PageCounter>
  );
};

PAGE_COUNTER.defaultProps = DefaultPageCounterProps;
export default PAGE_COUNTER;
